export function useValidationsMixin ({deepCheck = false}) {
  function getValidators () {
    function getValidators (component) {
      return component.$children.filter(i => i.$options.name === 'Validate')
    }

    let validators = getValidators(this)

    if (deepCheck) {
      // todo, actually here we are only checking for 2 deep, update this if you need more levels
      this.$children.forEach(child => {
        validators = [...validators, ...getValidators(child)]
      })
    }
    return validators
  }

  return {
    methods: {
      isAllValid () {
        // if deep is true we will check all children of children
        const validators = getValidators.bind(this)()

        return validators.length === validators.filter(i => i.valid).length
      },
      displayAllErrors () {
        getValidators.bind(this)().forEach(i => {
          i.setTouch(true)
        })
      }
    }
  }
}
